/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProcessingPartnerDto { 
    partnerName?: string;
    prefferedChannel?: number;
    phoneNumber?: string;
    link?: string;
    emailAddress?: string;
    serviceProviderName?: string;
    aggregatorName?: string;
    aggregatorId?: string;
}